var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImg9({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.98563689,3.50565026 L6.53327536,1.63926039 C6.9604872,1.32628668 7.52629983,1.27686103 8.00130583,1.51102295 L11.2312102,3.10325678 C11.7084383,3.33851412 12.0142497,3.82066972 12.0236496,4.35265122 L12.1792391,13.1581586 C12.1861713,13.5504807 11.873751,13.8741402 11.481429,13.8810724 C11.476924,13.881152 11.4724183,13.8811887 11.4679126,13.8811826 L4.01330378,13.8710622 C3.62092083,13.8705295 3.30326343,13.5520084 3.30379614,13.1596255 C3.3037995,13.1571473 3.30381583,13.1546692 3.30384513,13.1521912 L3.40453648,4.63511318 C3.40982017,4.18818632 3.62508093,3.76979213 3.98563689,3.50565026 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u63A7\\u4EF6",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-9",
    transform: "translate(-33.000000, -1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-11",
    transform: "translate(33.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u692D\\u5706\\u5F62-+-\\u8DEF\\u5F84-2-\\u8499\\u7248",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u8499\\u7248"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.452984, 6.493912) rotate(-15.000000) translate(-8.452984, -6.493912) translate(0.709289, -1.012175)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "\\u8499\\u7248",
    stroke: "none",
    fill: "#EA4B4D",
    fillRule: "evenodd",
    transform: "translate(7.743695, 7.506088) rotate(50.000000) translate(-7.743695, -7.506088) ",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3042938,5.56893617 C10.6700803,5.56893617 10.9666088,5.23662666 10.9666088,4.8267021 C10.9666088,4.41677754 10.6700803,4.08446803 10.3042938,4.08446803 C9.9385074,4.08446803 9.6419789,4.41677754 9.6419789,4.8267021 C9.6419789,5.23662666 9.9385074,5.56893617 10.3042938,5.56893617 Z",
    id: "\\u692D\\u5706\\u5F62",
    stroke: "#FFFFFF",
    strokeWidth: 0.535917043,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.73416379,
    y1: 6.70189266,
    x2: 7.35665329,
    y2: 13.5991133,
    id: "\\u8DEF\\u5F84-2",
    stroke: "#FFFFFF",
    strokeWidth: 0.710472837,
    fill: "none",
    mask: "url(#mask-4)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg9);
export default __webpack_public_path__ + "static/media/img9.9fa1d59ffafe174d0a7397783e0c5fb1.svg";
export { ForwardRef as ReactComponent };